import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query cyrilquery {
        file(relativePath: { eq: "cyril.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="Cyril est infirmier diplômé d'état de bloc opératoire"
        css={css`
          border-radius: 6px;
        `}
      />
    )}
  />
)
